package game.controller

import Button
import com.soywiz.kds.iterators.fastForEach
import com.soywiz.korev.GameButton
import com.soywiz.korev.GameStick
import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import game.Game
import game.PlayerInput
import game.Weapon
import view.Terminal

class PlayController : GameController() {
    private lateinit var buttonMap: Button
    private lateinit var buttonMenu: Button
    private lateinit var buttonHit: Button
    private lateinit var buttonUp: Button
    private lateinit var buttonDown: Button
    private lateinit var buttonLeft: Button
    private lateinit var buttonRight: Button

    private var pressUp = false
    private var pressDown = false
    private var pressLeft = false
    private var pressRight = false
    private var pressHit = false

    private val playerInput = PlayerInput()

    private var conveyorCoolDown = 0

    override fun onActivate(game: Game) {
        buttonMap = addButton(game.text("Button_Map"), 14, 8, 12, 3) {
            showMap(game)
        }

        buttonMenu = addButton(game.text("Button_Menu"), 2, 11, 24, 3) {
            game.controller = InventoryController()
        }

        buttonHit = addButton(game.text("Button_Hit"), 74, 22, 6, 3)
        buttonHit.onDown = { pressHit = true }
        buttonHit.onUp = { pressHit = false }

        buttonUp = addButton(game.settings.keyboard.moveUp1.name, 10, 15, 7, 3)
        buttonUp.onDown = { pressUp = true }
        buttonUp.onUp = { pressUp = false }

        buttonDown = addButton(game.settings.keyboard.moveDown1.name, 10, 21, 7, 3)
        buttonDown.onDown = { pressDown = true }
        buttonDown.onUp = { pressDown = false }

        buttonLeft = addButton(game.settings.keyboard.moveLeft1.name, 4, 18, 7, 3)
        buttonLeft.onDown = { pressLeft = true }
        buttonLeft.onUp = { pressLeft = false }

        buttonRight = addButton(game.settings.keyboard.moveRight1.name, 16, 18, 7, 3)
        buttonRight.onDown = { pressRight = true }
        buttonRight.onUp = { pressRight = false }
    }

    private fun showMap(game: Game) {
        game.controller = MapController()
    }

    override fun onDeactivate(game: Game) {
        pressUp = false
        pressDown = false
        pressLeft = false
        pressRight = false
        pressHit = false
    }

    override fun onTick(game: Game, input: Input) {
        if (conveyorCoolDown > 0) {
            conveyorCoolDown--
        } else {
            with(game.currentRoom) {
                entities.filter {
                    !it.fixed
                }.fastForEach {
                    when (this[it.col, it.row].char) {
                        0x1E -> it.row--
                        0x1F -> it.row++
                        0x10 -> it.col++
                        0x11 -> it.col--
                    }
                }
            }

            // Conveyor
            with(game.player) {
                var desiredCol = col
                var desiredRow = row
                when (game.currentRoom[col, row].char) {
                    0x1E -> desiredRow--
                    0x1F -> desiredRow++
                    0x10 -> desiredCol++
                    0x11 -> desiredCol--
                    else -> {
                    }
                }

                if (desiredCol != col || desiredRow != row) {
                    game.playSound("conveyor")
                    doMove(game, desiredCol, desiredRow)
                }
            }

            conveyorCoolDown = 4
        }

        buttonMap.visible = game.player.map && game.currentRoom.level in 1..2
        buttonHit.visible = game.player.weapon != Weapon.None

        if (game.player.map && input.keys.justPressed(Key.M)) {
            showMap(game)
        } else if (input.keys.justPressed(Key.ESCAPE) || input.keys.justPressed(Key.F10)) {
            game.controller = InventoryController()
        } else {
            game.currentRoom.tick(game)

            playerInput.left = pressLeft ||
                    input.keys.pressing(game.settings.keyboard.moveLeft1) ||
                    input.keys.pressing(game.settings.keyboard.moveLeft2)

            playerInput.right = pressRight ||
                    input.keys.pressing(game.settings.keyboard.moveRight1) ||
                    input.keys.pressing(game.settings.keyboard.moveRight2)

            playerInput.up = pressUp ||
                    input.keys.pressing(game.settings.keyboard.moveUp1) ||
                    input.keys.pressing(game.settings.keyboard.moveUp2)

            playerInput.down = pressDown ||
                    input.keys.pressing(game.settings.keyboard.moveDown1) ||
                    input.keys.pressing(game.settings.keyboard.moveDown2)

            playerInput.hit = pressHit ||
                    input.keys.pressing(game.settings.keyboard.hit1) ||
                    input.keys.pressing(game.settings.keyboard.hit2)

            if (input.gamepads.isNotEmpty()) {
                playerInput.left = playerInput.left || input.gamepads[0].getX(GameStick.LEFT) < -0.5
                playerInput.right = playerInput.right || input.gamepads[0].getX(GameStick.LEFT) > 0.5
                playerInput.up = playerInput.up || input.gamepads[0].getY(GameStick.LEFT) < -0.5
                playerInput.down = playerInput.down || input.gamepads[0].getY(GameStick.LEFT) > 0.5
                playerInput.hit = playerInput.hit ||
                        input.gamepads[0][GameButton.BUTTON0] > 0.5 ||
                        input.gamepads[0][GameButton.BUTTON1] > 0.5 ||
                        input.gamepads[0][GameButton.BUTTON2] > 0.5 ||
                        input.gamepads[0][GameButton.BUTTON3] > 0.5
            }
            game.player.tick(game, playerInput)
        }

        if (game.player.life == 0) {
            game.controller = GameOverController()
        }
    }


    override fun onRender(game: Game, terminal: Terminal) {
        game.renderUi(terminal)
        game.renderStage(terminal)
    }
}
